/* 布局 */
//前台
import Layout from "@views/layout";

const graveareatransferRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "graveareatransfer/list",
        name: "GRAVEAREATRANSFER",
        meta: {
            title: "墓穴迁移申请",
            keepAlive:true
        },
        component: () => import("@views/business/graveareatransfer/index.vue"),
    },
        ],
};

export default graveareatransferRouter;
